const INSTALLEMENTS = 3;

export const getAmountForTheRest = (amount: number) =>
  (amount - (amount % INSTALLEMENTS)) / INSTALLEMENTS;

export const getAmountForTheFirst = (amount: number) =>
  getAmountForTheRest(amount) + (amount % INSTALLEMENTS);
